// util
import { defineStore } from 'pinia';

/**
 * 获取安全的状态栏高度
 * 优先级：原生获取 > CSS环境变量 > 默认值
 * @returns {Number} 状态栏高度（px）
 */
function getSafeStatusBarHeight() {
  // 1. 尝试从 CSS 环境变量获取（支持刘海屏）
  if (typeof window !== 'undefined' && window.getComputedStyle) {
    const root = document.documentElement;
    const safeAreaTop = getComputedStyle(root).getPropertyValue('--safe-area-inset-top');
    
    if (safeAreaTop) {
      const height = parseInt(safeAreaTop);
      if (!isNaN(height) && height > 0) {
        console.log('从CSS环境变量获取状态栏高度:', height);
        return height;
      }
    }
  }
  
  // 2. 根据设备类型设置默认值
  const userAgent = navigator.userAgent;
  
  // iPhone X 及以上（刘海屏）
  if (/iPhone/.test(userAgent)) {
    const isIPhoneX = /iPhone X|iPhone 1[0-9]|iPhone 1[0-9] Pro/.test(userAgent) || 
                      (window.screen.height >= 812 && window.screen.width >= 375);
    if (isIPhoneX) {
      console.log('检测到iPhone刘海屏，使用44px');
      return 44; // iPhone X 及以上
    }
    console.log('检测到普通iPhone，使用20px');
    return 20; // 普通 iPhone
  }
  
  // Android 设备
  if (/Android/.test(userAgent)) {
    console.log('检测到Android设备，使用24px');
    return 24;
  }
  
  // iPad
  if (/iPad/.test(userAgent)) {
    console.log('检测到iPad，使用20px');
    return 20;
  }
  
  // 默认值
  console.log('使用默认状态栏高度: 24px');
  return 24;
}

export const useGlobalStore = defineStore('global', {
  state: () => ({
    statusBarHeight: getSafeStatusBarHeight(), // 顶部状态栏高度（智能获取）
    keepAliveList: ['healthHomePage'] // 需要缓存的页面
  }),
  actions: {
    // 设置顶部状态栏高度
    setStatusBarHeight(height) {
      // 验证高度值的有效性
      if (height && !isNaN(height) && height > 0 && height < 200) {
        console.log('设置状态栏高度:', height);
        this.statusBarHeight = height;
      } else {
        console.warn('无效的状态栏高度值:', height, '使用当前值:', this.statusBarHeight);
      }
    },
    // 添加keepAlive项目
    addKeepAlive(name) {
      if (this.keepAliveList.includes(name)) {
        return;
      }
      const keepAliveList = [...this.keepAliveList];
      keepAliveList.push(name);
      this.keepAliveList = keepAliveList;
    },
    // 移除keepAlive项目
    removeKeepAlive(name) {
      if (!this.keepAliveList.includes(name)) {
        return;
      }
      const keepAliveList = [...this.keepAliveList];
      this.keepAliveList = keepAliveList.filter(item => item !== name);
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/global.js